import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225 } from "@faire/retailer-settings/FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { useSearchParams } from "next/navigation";

import { isSemTraffic } from "../lib/navigation-origin/isComingFromSEM";

export const useSettingEnableDiscoverCategoryCTABanners =
  (): IThreeVariantXP.Bucket => {
    const searchParams = useSearchParams();
    const isSEM = isSemTraffic(Object.fromEntries(searchParams.entries()));
    const assignment = useSetting(
      FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225
    );
    return isSEM ? IThreeVariantXP.Bucket.CONTROL : assignment;
  };

export const useAssignSettingEnableDiscoverCategoryCTABanners = () =>
  useAssignSetting(FE_BATCH_12_CATEGORY_DISCOVER_CTA_INTERSPERSED_081225);
